export default __webpack_public_path__ + "static/media/PRIMARY - GHOST.ec1983fe.svg";